import endpoints from "../config/endpoints";
import axios from "../utils/axiosExt";
import localforage from "localforage";
import Auth from "./../utils/auth";
import { errorLogger } from "./applicationLogUtils";

localforage.config({
    name: 'RCH-2.0',
    storeName: 'imageCache'
});

const fetchImageCacheImage = async (userImageBuffer: any) => {
try {
    if(userImageBuffer){
        const buffferResponse = await axios.post(endpoints.getImageTenByUserID, {
            "userId": userImageBuffer
          },Auth.loggedIn());
            if(buffferResponse?.data?.data[0]) {
                const listImageBuffer = buffferResponse?.data?.data[0];
                listImageBuffer.forEach(async(v:any) => {
                    if(v?.image?.data) {
                        await localforage.setItem(v.user_id, v.image.data);
                    }
                });
            }
        return Promise.resolve();
    }
} catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
}

export default fetchImageCacheImage;